let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5088Q")).then(() => parcelRequire('3gwUr'));